import { BotAvatar } from "./BotAvatar";
import "../../assets/styles/chat-message.css";

export const Thinking = () => (
  <div className="mx-4 flex flex-col justify-end">
    <div className="flex flex-row items-center gap-3">
      <BotAvatar />
      <div className="bg-secondary rounded-2xl px-4 py-3">
        <div className="typing flex items-center gap-1">
          <span className="inline-block h-1 w-1 rounded-full bg-gray-300" />
          <span className="inline-block h-1.5 w-1.5 rounded-full bg-gray-300" />
          <span className="inline-block h-2 w-2 rounded-full bg-gray-300" />
        </div>
      </div>
    </div>
  </div>
);
